<template>
  <div>
    <b-modal
        scrollable
      id="add-article-direct"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('AddArticle')}`"
      hide-footer
      @hide="onCancel"
    >
      <b-form-group
        :label="$t('Name')"
      >
        <b-form-input
          v-model="name"
          :placeholder="$t('Name')"
        />
      </b-form-group>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          style="background: #FF274F !important;"

          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; ; background: white; color: black; border-color: white;font-weight: 400;"

          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      name: null,
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {

  },
  methods: {
    ...mapActions([]),
    onSubmit() {
      const object = {
        name: this.name,
        lovDressCategoryId: null,
      }
      this.$emit('addArticle', object)
      this.onReset()
    },
    onCancel() {
      this.onReset()
    },
    onReset() {
      this.name = null
      this.$refs.modal.hide()
    },
  },
}
</script>

  <style lang="scss" scoped>

  </style>
